import { Component, OnInit, Compiler, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ViewConsentService } from './view-consent.service';
import { environment as ENV } from '../../../environments/environment';
import { AddCoapplicantComponent } from '../add-coapplicant/add-coapplicant.component';
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
import { ApplicantService } from 'app/laas/applicant.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import { LaasComponent } from 'app/laas/laas.component';
import { OpenDialog } from 'app/laas/dialog-for-cbs/dialog.component';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
// import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { AddCoapplicantComponent} from '../add-coapplicant/add-coapplicant.component'

@Component({
  selector: 'wl-loader-dialog',
  template: `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;">
    <i class="fa fa-spinner fa-pulse fa-2x fa-fw" style="color:#506c84;margin:0 auto;display:block;"></i>
      <p>Loading Data For the First time.. Please Wait..</p>
    </div>
  `
})
export class LoaderDialogConsentComponent {
  message: string

  constructor(
    // public dialogRef: MatDialogRef<LoaderDialogComponent>
    public bsModalRef: BsModalRef,
  ) { }
}

@Component({
  selector: 'wl-view-consent',
  templateUrl: './view-consent.component.html',
  styleUrls: ['./view-consent.component.scss'],
  providers: [
    ViewConsentService,
    AddCustomerService,
    ApplicantService,
    AdminService,
    LaasComponent,
  ],
})
export class ViewConsentComponent implements OnInit {
  allUsers: Observable<any>;
  loading: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  role: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  adminForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  makerOnly: boolean = true;
  pageId: any = 1;
  @ViewChild('date1') firstDate: ElementRef;
  @ViewChild('date2') secondDate: ElementRef;
  showSelectedDate: boolean;
  selectedDate: string;
  showFilter1: boolean = false;
  showFilter2: boolean = false;
  showFilter3: boolean = false;
  showPending: boolean = false;
  currentDate: any;
  heading: string;
  showForConsentNo = false;
  searchFilter: string;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showConsentDataTable: boolean = true;
  filter: string = '';

  constructor(
    private customer: ViewConsentService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private cust: AdminAuthService,
    private fb: UntypedFormBuilder,
    private applicant: ApplicantService,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    // public modalService: NgbModal
    private modalService: BsModalService,
    private laas: LaasComponent,
    private advancedFilterService: AdvancedFilterService
  ) {
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],

      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: [''],
      fromdate: ['', Validators.required],
      // todate: ['', Validators.required]
    });

    let urlSplit = window.location.href.split('/')[window.location.href.split('/').length - 1];
    if (urlSplit == 'view-consent-yes') {
      this.heading = "Consent 'YES'";
      this.searchFilter = 'Yes';
    } else if (urlSplit == 'view-consent-no') {
      this.heading = "Consent 'NO'";
      this.showForConsentNo = true;
      this.searchFilter = 'No';
    } else if (urlSplit == 'view-consent-dnr') {
      this.heading = "Consent 'DNR'";
      this.showForConsentNo = true;
      this.searchFilter = 'DNR';
    } else if (urlSplit == 'view-consent-pending') {
      this.heading = 'Consent Pending';
    }

    this.iscredCount = ENV.creditScoreSetting.credCount;

    this.showOrHide = true;

    this.searchHolder = 'Search Applicant by Name / Customer ID';

    this.display = false;
  }
  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;

    if (this.isCoLogin()) {
      this.applyFilter(this.filter, 0, 1, 1);
      return;
    }

    this.page = 1;
    this.pageId = 1;
    this.loading = true;

    this.customer.getUsers(value, this.roleId, 0, 10, this.searchFilter).subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      error: (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.loading = false;
        throw err;
      }
    });
  }

  ngOnInit() {
    this.roleId = this.customer.getRoleId();
    if (this.isCoLogin()) {
      this.showConsentDataTable = false;
    }

    sessionStorage.removeItem('filterDateViewConsentStart');
    sessionStorage.removeItem('filterDateViewConsentEnd');
    this.maxDate = this.adminservice.getCurrentMonth();
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    this.currentDate = moment().format('YYYY-MM');
    // const token = sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');
    console.log('decrypted ' + JSON.stringify(atob(encrypted)));
    // var jwtObj = this.jwt.decodeToken(token)
    // console.log("jwt token " + JSON.stringify(jwtObj));

    this.showFilter1 =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'view-consent-yes'
        ? true
        : false;
    this.showFilter2 =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'view-consent-no'
        ? true
        : false;
    this.showFilter3 =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'view-consent-dnr'
        ? true
        : false;
    this.showPending =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'view-consent-pending'
        ? true
        : false;

    // var roleObj = this.cust.getRole();
    // console.log("roleObj " + JSON.stringify(roleObj))
    // var parsedRole = JSON.parse(roleObj);
    // this.role = roleObj.role;
    this.role = sessionStorage.getItem('wzbvdsjvbbs');
    console.log('role ' + this.role);

    if (sessionStorage.getItem('filterDateViewConsent')) {
      this.currentDate = moment(sessionStorage.getItem('filterDateViewConsent'), 'YYYY-MM-DD').format(
        'YYYY-MM'
      );
      let selected = this.currentDate;
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var another = months[+selected.split('-')[1] - 1];
      this.selectedDate = another + ', ' + selected.split('-')[0];
      this.showSelectedDate = true;
    }
    this.roleId = sessionStorage.getItem('getroleId');
    console.log('this.roleId ' + this.roleId);

    !this.isCoLogin() && this.getAllUsers('', this.roleId, 0, 10);

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateViewConsentStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateViewConsentEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          this.searchFilter,
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            this.allUsers = res.result.resultData ? res.result.resultData : '';
            this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   var another = months[+selected.split('-')[1] - 1];
  //   this.selectedDate = another + ', ' + selected.split('-')[0];
  //   console.log(this.firstDate.nativeElement.value);
  //   let filterDate = this.firstDate.nativeElement.value + '-01';
  //   sessionStorage.setItem('filterDateViewConsent',filterDate)
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime()
  //   this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs, this.searchFilter).subscribe(res => {
  //     console.log(res);
  //     if(res && res.result && res.result.resultData){
  //       this.allUsers = res.result.resultData?res.result.resultData:"";
  //       this.totalCount = res && res.result && res.result.count?res.result.count:0;
  //       this.totalPage = Math.ceil(this.totalCount / 10);
  //     }
  //   })
  // } else{
  //   this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  // }
  // }

  getAllUsers(input, roleId, offset, limit) {
    this.loading = true;

    this.customer.getUsers(input, roleId, offset, limit, this.searchFilter).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
        }

        // if(res && res.count && res.result.count){
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);
        // }

        console.log('this.allUsers ' + JSON.stringify(this.allUsers));

        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
    // this.customer.getUsers(this.search.value, pageId).subscribe(res => {
    //   this.loading = false;
    //   this.allUsers = res.result;
    //   this.totalCount = res.count;
    //   this.totalPage = Math.ceil(this.totalCount / 10);
    //   this.custId = res.result.custId;
    //   console.log("custId " +  res.result.custId);
    // }, err => {
    //   this.loading = false;
    //   this.allUsers = Observable[''];
    //   throw err
    // })
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, this.searchFilter).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
        }
        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getRocCount() {
    this.customer.getRocCounts().subscribe((res) => {
      this.rocCount = res;
    });
  }

  View(user) {
    sessionStorage.setItem('wl-applicant-id', user);
    sessionStorage.setItem('applicantId', user);
    sessionStorage.setItem('lrOpenedFromAdmin', 'false');
    window.open(ENV.urlSetting.url + 'laas/consent-form');
  }

  getLogReport() {
    const data = {
      custId: this.adminId,
      type: 1,
    };
    // const message = "data"
  }

  retailCheck(isRetail) {
    console.log('retail...1 ', isRetail);
    // this.customer.isRetail = isRetail;
    if (isRetail == true) {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'tDrfsud25362htsjddh');
    } else {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'fFywshdssf7d9123dnd');
    }
  }
  openDialog(customerId, type, isRetail) {
    console.log('customer id === > ', customerId);
    console.log('type === > ', type);
    console.log('isRetail === > ', isRetail);
    const data = {
      custId: customerId,
      type: type,
      isRetail: isRetail,
    };

    this.bsModalRef = this.modalService.show(AddCoapplicantComponent, {
      animated: false,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: data,
    });
    this.bsModalRef.content.onClose.subscribe((result) => {
      console.log('results', result);
    });
  }

  getType(app, coapp, guarantor) {
    if (app) {
      return 'Applicant';
    } else if (coapp) {
      return 'Co-Applicant';
    } else {
      return 'Guarantor';
    }
  }


  sendSms(applicantId) {
    // console.log(applicantId);
    // debugger
    this.applicant.sendSmsManual(applicantId).subscribe((res) => {
      console.log(res, 'Resp');
      res.result == 'sent'
        ? this.snackbar.open('SMS Sent', 'OK', { duration: 3000 })
        : this.snackbar.open(res.message, 'OK', { duration: 3000 });
    });
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateViewConsentStart');
    sessionStorage.removeItem('filterDateViewConsentEnd');
    sessionStorage.removeItem('filterDateViewConsent');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  get_consent_approval_date(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let consent_approval_date = this.allUsers[i].consent_approval_date
        ? this.allUsers[i].consent_approval_date
        : '';

      if (consent_approval_date) {
        var date = moment(consent_approval_date);
        var dateComponent = date.utc().format('DD-MM-YYYY');
        return dateComponent;
      } else {
        return '';
      }
    }
  }

  isCoLogin() {
    if (this.roleId === '1') {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showConsentDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    formData.searchFilter = this.searchFilter;
    try {
      this.customer.getConsent(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          let resultSet =
            response && response.result && response.result.resultData
              ? response.result.resultData
              : [];
          this.allUsers = resultSet;
          if (!resultSet.length) {
            this.noUserFound = 'Customer data not found';
          }
          this.totalCount =
            response && response.result && response.result.count ? response.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }
}
